if (!customElements.get('accordions-group')) {
  class AccordionsGroup extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
    }

    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('details'));

      this.details.forEach((detail) => {
        detail.addEventListener('toggle', this.onToggle);
      });
    }

    disconnectedCallback() {
      this.details.forEach((detail) => {
        detail.removeEventListener('toggle', this.onToggle);
      });
    }

    onToggle(event) {
      const current = event.target;

      if (!(current instanceof HTMLDetailsElement)) return;

      if (current.open) {
        this.details.forEach((detail) => {
          if (detail !== current) {
            detail.open = false;
          }
        });
      }
    }
  }

  customElements.define('accordions-group', AccordionsGroup);
}
